import { render } from "./AcreditadoSectionInsitu.vue?vue&type=template&id=383e9c6b&ts=true"
import script from "./AcreditadoSectionInsitu.vue?vue&type=script&lang=ts"
export * from "./AcreditadoSectionInsitu.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__